import template from './dateTimeRangePicker.component.html';

/* @ngInject */
function DateTimeRangePickerController(ModalService) {
  const vm = this;

  vm.showPicker = () => {
    if (vm.modalMode) {
      openModal();
    } else {
      vm.showDateRangeSelector = !vm.showDateRangeSelector;
    }
  };

  vm.done = () => {
    vm.showDateRangeSelector = false;
  };
  vm.cancel = () => {
    vm.showDateRangeSelector = false;
  };

  function openModal() {
    ModalService.open({
      component: 'dateTimeRangePickerModal',
      size: 'md',
      resolve: {
        start: () => vm.start,
        end: () => vm.end
      }
    }).then(({ start, end }) => {
      vm.start = start;
      vm.end = end;
      vm.changed = true;
    });
  }

}


export default {
  name: 'dateTimeRangePicker',
  template,
  controller: DateTimeRangePickerController,
  bindings: {
    start: '=?',
    end: '=?',
    changed: '=?',
    horizontal: '<?',
    modalMode: '<?'
  }
};
